const listeners = {};

export const sendMessage = (signal, data) => {
	window.parent.postMessage({
		signal, data, from: 'anybot'
	}, '*');
};

export const onMessage = (signal, fn) => {
	if(!listeners[signal]) {
		listeners[signal] = [fn];
	} else {
		listeners[signal].push(fn);
	}
};

export const offMessage = (signal, fn) => {
	if(!listeners[signal]) return;
	listeners[signal] = listeners[signal].filter(e => e !== fn);
}

export const init = () => {
	window.addEventListener('message', ({ data: { data, from, signal } }) => {
		if (from === 'anybot') {
			listeners[signal]?.forEach(fn => {
				fn(data);
			});
		}
	}, false);
};

export default {
	sendMessage,
	onMessage,
	offMessage,
	init
};